<span [ngClass]="{'_load-animate _load-active': ui.loading}">
  <div class="_dialog-title">
    <mat-icon svgIcon="logo" class="me-2"></mat-icon>
    <span>{{title | translate}}</span>
  </div>

  <div class="_dialog-content">
    <mat-tab-group class="wiz-tabs hide-headers" [(selectedIndex)]="step">
      <!--LOGIN START-->
      <mat-tab>
        @if (step == stepsMap.sign) {
          <form #signInForm="ngForm" [formGroup]="signFormGroup">
            <p>{{'_LOYALTY.sign_other' | translate}}</p>
            <mat-form-field color="accent" appearance="outline" class="with-pad">
              <oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
                [onlyCountries]="appService.regionArgs.phoneOnlyCountries"
                [enablePlaceholder]="true"
                [enableSearch]="true"
                [searchPlaceholder]="appService.translate('search')"
                format="national"
                name="phone"
                formControlName="phone"
                required
              #phone></oao-mat-intl-tel-input>
              <!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
              <!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
              @if (signInForm.form.controls['phone']?.errors?.validatePhoneNumber) {
                <mat-error>{{'invalid_phone' | translate}}</mat-error>
              }
            </mat-form-field>
            <!--<div class="mb-3" *ngIf="appService.cachedPaymentInfo">
            <mat-checkbox name="savePaymentInfo" formControlName="savePaymentInfo">
              {{'MESSAGES.SAVE_INFO_PAYMENT' | translate}}
            </mat-checkbox>
          </div>-->
          @if (ui.licenseCaption) {
            <div class=" text-center text-xs mb-4 mt-2">
              <div>{{ui.licenseCaption | translate}}</div>
              <div class="flex a-center j-center">
                <a class="inline link me-2" (click)="appService.showContractDialog('contract')">{{'READ_AND_APPROVE_CONTRACT_C' | translate}}</a>
                <a class="inline link" (click)="appService.showContractDialog('privacy')">{{'READ_AND_APPROVE_CONTRACT_D' | translate}}</a>
              </div>
            </div>
          }
          <div class="_bottom-actions">
            <button type="button" mat-button class="_cancel" (mousedown)="cancel()">{{'Cancel' | translate}}</button>
            <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="signIn()">{{'sign_in_action' | translate}}</button>
          </div>
        </form>
      }
    </mat-tab>
    <!--LOGIN END-->
    <!--REGISTER START-->
    <mat-tab>
      <form (ngSubmit)="signUp(signUpForm)" #signUpForm="ngForm">

        <p>{{'sign_up_message' | translate}}</p>

        <mat-form-field color="accent" appearance="outline">
          <mat-label>{{'first_name' | translate}}</mat-label>
          <input matInput #FN="ngModel" type="text" [(ngModel)]="formModel.FirstName" name="FirstName" validName required>
          @if (formModel.FirstName) {
            <mat-icon matSuffix (click)="formModel.FirstName = null">close</mat-icon>
          }
          @if (FN.dirty && FN.errors?.nameField) {
            <mat-error>{{FN.errors.nameField | translate}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field color="accent" appearance="outline">
          <mat-label>{{'last_name' | translate}}</mat-label>
          <input matInput #LN="ngModel" type="text" [(ngModel)]="formModel.LastName" name="LastName" validName required>
          @if (formModel.LastName) {
            <mat-icon matSuffix (click)="formModel.LastName = null">close</mat-icon>
          }
          @if (LN.dirty && LN.errors?.nameField) {
            <mat-error>{{LN.errors.nameField | translate}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field color="accent" appearance="outline">
          <mat-label>{{'email' | translate}}</mat-label>
          <input matInput [placeholder]="'email' | translate" [(ngModel)]="formModel.Email" name="email" type="email" email required class="ltr-field">
          @if (formModel.email) {
            <mat-icon matSuffix (click)="formModel.email = null">close</mat-icon>
          }
        </mat-form-field>

        @if (appService.cachedPaymentInfo) {
          <div class="mt-3">
            <mat-checkbox name="savePaymentInfo" [(ngModel)]="savePaymentInfo">
              {{'MESSAGES.SAVE_INFO_PAYMENT' | translate}}
            </mat-checkbox>
          </div>
        }

        <div class="_bottom-actions">
          <button type="button" mat-button class="_cancel" (click)="cancel()">{{'Cancel' | translate}}</button>
          <button type="submit" mat-flat-button color="accent" class="rounded">{{'sign_up_action' | translate}}</button>
        </div>

      </form>
    </mat-tab>
    <!--REGISTER END-->
    <!--CHALLENGE START-->
    <mat-tab>
      <form (ngSubmit)="confirmPhone(challengeForm)" #challengeForm="ngForm" class="">

        <p>
          {{'enter_code_message' | translate}}
          <span style="display:block" class="ltr-field">{{formModel.phone | phone}}</span>
        </p>

        <mat-form-field color="accent" appearance="outline">
          <mat-label>{{'verification_code' | translate}}</mat-label>
          <input matInput type="tel" [(ngModel)]="formModel.code" name="code" required minlength=4 maxlength=4>
          @if (formModel.code) {
            <mat-icon matSuffix (click)="formModel.code = null">close</mat-icon>
          }
        </mat-form-field>


        <div class="text-far" style="position:relative; top: -8px; margin-bottom: 15px;">
          <button type="button" mat-button (click)="resendPinCode()">
            {{'resend' | translate}}
          </button>
        </div>

        @if (enableAnonymousLogin) {
          <div class="text-center" style="position:relative; margin-bottom: 15px; top: -10px">
            <button type="button" class="btn btn-outline-primary" (click)="loginAnonymous()">
              <span style="white-space: pre-line" [innerHTML]="'auth_enable_anonymous' | translate"></span>
            </button>
          </div>
        }


        <div class="_bottom-actions">
          <button type="button" mat-button class="_cancel" (click)="cancel()">{{'Cancel' | translate}}</button>
          <button type="submit" mat-flat-button color="accent" class="rounded">{{'continue' | translate}}</button>
        </div>
      </form>
    </mat-tab>
    <!--CHALLENGE END-->
    <!--START ANONYMOUS LOGIN -->
    <!--END ANONYMOUS LOGIN -->
  </mat-tab-group>
</div>
</span>
